/**
 * @fileoverview GET handler for the "/engagement/message_variations_for_uco/:campaign_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementMessageVariationsForUcoCampaignId } from "./constants";
import type { MessageVariationsForUcoResult } from "./types";
import { isMessageVariationsForUcoResult } from "./validators";

export const getMessageVariationsForUco = reactQueryFetcherAdapter(
  engagementMessageVariationsForUcoCampaignId,
  (signal: AbortSignal, campaignId: string): Promise<MessageVariationsForUcoResult> => {
    return fetch(`/engagement/message_variations_for_uco/${campaignId}`, "GET", {}, { signal });
  },
  isMessageVariationsForUcoResult
);
